import {
  LISTA_NOTICIAS,
  LISTA_NOTICIAS_SUCESSO,
  LISTA_NOTICIAS_ERRO,
  CRIA_NOTICIA,
  CRIA_NOTICIA_SUCESSO,
  EDITA_NOTICIA,
  EDITA_NOTICIA_SUCESSO,
  DELETA_NOTICIA,
  DELETA_NOTICIA_SUCESSO,
  TOGGLE_ATIVO_NOTICIA,
  TOGGLE_ATIVO_NOTICIA_SUCESSO,
  NOTICIAS_ERRO,
} from 'constants/ActionTypes';

const INIT_STATE = {
  carregando: false,
  enviando: false,
  items: [],
  total: 0,
  totalPaginas: 0,
  pagina: 1,
  tamanhoPagina: 20,
  erro: null,
  sucesso: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case LISTA_NOTICIAS:
      return { ...state, carregando: true, erro: null, sucesso: false };

    case LISTA_NOTICIAS_SUCESSO:
      return {
        ...state,
        carregando: false,
        items: action.payload.items,
        total: action.payload.total,
        totalPaginas: action.payload.totalPaginas,
        pagina: action.payload.pagina,
        tamanhoPagina: action.payload.tamanhoPagina,
      };

    case LISTA_NOTICIAS_ERRO:
      return { ...state, carregando: false, erro: action.payload };

    case CRIA_NOTICIA:
    case EDITA_NOTICIA:
    case DELETA_NOTICIA:
    case TOGGLE_ATIVO_NOTICIA:
      return { ...state, enviando: true, erro: null, sucesso: false };

    case CRIA_NOTICIA_SUCESSO:
    case EDITA_NOTICIA_SUCESSO:
    case DELETA_NOTICIA_SUCESSO:
    case TOGGLE_ATIVO_NOTICIA_SUCESSO:
      return { ...state, enviando: false, sucesso: true };

    case NOTICIAS_ERRO:
      return { ...state, enviando: false, carregando: false, erro: action.payload };

    default:
      return state;
  }
};
